import { render } from "./NewsBookmarks.vue?vue&type=template&id=ac7cb4f8&scoped=true"
import script from "./NewsBookmarks.vue?vue&type=script&lang=js"
export * from "./NewsBookmarks.vue?vue&type=script&lang=js"

import "./NewsBookmarks.vue?vue&type=style&index=0&id=ac7cb4f8&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7cb4f8"]])

export default __exports__